import React from 'react';
import './App.css';
import {ApolloProvider} from "./ApolloProvider";
import {BrowserRouter as Router, Redirect, Route, Switch} from "react-router-dom";

import ReportScorePage from './report-score/ViewDecider';
import TeamHomePage from './team-home-page/ViewDecider';
import TeamSchedulePageRouter from './team-schedule';
import {SearchableSchedule} from "./searchable-schedule";
import StandingsPage from './standings'

function App() {
  return (
    <Router>
      <ApolloProvider>
        <Content />
      </ApolloProvider>
    </Router>
  )
}

function Content() {
  return (
    <Switch>
      <Route exact path={'/report-score'}>
        <ReportScorePage />
      </Route>

      <Route exact path={'/home'}>
        <TeamHomePage />
      </Route>

      <Route exact path={'/schedule'}>
        <TeamSchedulePageRouter />
      </Route>

      <Route exact path={'/standings'}>
        <StandingsPage />
      </Route>

      <Route exact path={'/searchable-schedule'}>
        <SearchableSchedule />
      </Route>

      <Route>
        <Redirect
          to={'/home'}
        />
      </Route>
    </Switch>
  );
}

export default App;
